import {Placeholder as PeacockPlaceholder} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').IPlaceholderProps} PlaceholderProps
 */

/**
 * Wrapper around Peacock DS Placeholder.
 * Supports all Peacock DS placeholder props.
 * @param {PlaceholderProps} props
 */
export const Placeholder = props => {
  return <PeacockPlaceholder {...props} />
}